/* eslint-disable no-unused-vars */
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import StudentGradebookContainerWrapper from './components/StudentGradebookContainer';
import InstructorGradebookContainerWrapper from './components/InstructorGradebookContainer';
import SearchAcrossSectionsContainerWrapper from './components/SearchAcrossSectionsContainer';

import './index.css';

let studentRoot = null;
let instructorRoot = null;
let searchAcrossSectionsRoot = null;

const mountComponent = (containerId, Component, componentName, props) => {
  const container = document.getElementById(containerId);
  if (!container) {
    // eslint-disable-next-line no-console
    console.error(
      `Failed to render ${componentName}: container with id "${containerId}" not found`,
    );
    return null;
  }
  const root = createRoot(container);
  root.render(<Component {...props} />);
  return root;
};

// mount micro frontend functions
window.renderStudentGradebook = (containerId, externalProps, history) => {
  studentRoot = mountComponent(
    containerId,
    StudentGradebookContainerWrapper,
    'Student Gradebook',
    externalProps,
  );
};

window.renderInstructorGradebook = (containerId, externalProps, history) => {
  instructorRoot = mountComponent(
    containerId,
    InstructorGradebookContainerWrapper,
    'Instructor Gradebook',
    externalProps,
  );
};

window.renderSearchAcrossSections = (containerId, externalProps, history) => {
  searchAcrossSectionsRoot = mountComponent(
    containerId,
    SearchAcrossSectionsContainerWrapper,
    'Search Across Sections',
    externalProps,
  );
};

// unmount micro frontend functions
window.unmountStudentGradebook = () => {
  if (studentRoot) {
    studentRoot.unmount();
    studentRoot = null;
  }
};

window.unmountInstructorGradebook = () => {
  if (instructorRoot) {
    instructorRoot.unmount();
    instructorRoot = null;
  }
};

window.unmountSearchAcrossSections = () => {
  if (searchAcrossSectionsRoot) {
    searchAcrossSectionsRoot.unmount();
    searchAcrossSectionsRoot = null;
  }
};

// Mount to root if it is not a micro frontend
// Only mount standalone app if we're on the gradebook's client domain
const isGradebookDomain =
  window.location.hostname.includes('gradebook-client') ||
  window.location.hostname.includes('gradebook-api-frontend');

if (
  isGradebookDomain &&
  !document.getElementById('StudentGradebook-micro-container') &&
  !document.getElementById('InstructorGradebook-micro-container') &&
  !document.getElementById('SearchAcrossSections-micro-container')
) {
  try {
    const container = document.getElementById('container');
    if (container) {
      const root = createRoot(container);
      root.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>,
      );
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(
      'Gradebook standalone error: rendering standalone app:',
      error,
    );
  }
}
